export default __webpack_public_path__ + "static/media/JulyDom2024.bcfeb1ff.png";